import Icon from '../../components/Icon.vue'

Icon.register({"brands/black-tie":{"width":448,"height":512,"paths":[{"d":"M0 32V480H448V32H0zM316.5 357.2L224 445.9 131.5 357.2 196 173.2 131.5 86.6H316.4L252 173.2 316.5 357.2z"}]}})
